import React, { useState } from "react";

import { Button } from "semantic-ui-react";

import HeaderCustom from "./HeaderCustom";
import InformationFormBasic, { InformationDataType } from "./InformationFormBasic";
import InformationFormDetailed from "./InformationFormDetailed";

type RegisterInformationProps = {
  data: InformationDataType;
  layout?: "basic" | "detailed";
  healthFacilityTypeOptions: Record<string, any>[];
  onCancel: () => void;
  onSave: () => Promise<void>;
};

type CheckInformationProps = RegisterInformationProps & {};

const CheckInformation: React.FC<CheckInformationProps> = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    setIsLoading(true);

    await props.onSave();

    setIsLoading(false);
  };

  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <>
      {props.layout === "detailed" ? (
        <InformationFormDetailed
          detail={props.data}
          readOnly
          healthFacilityTypeOptions={props.healthFacilityTypeOptions}
        />
      ) : (
        <>
          <HeaderCustom label="ตรวจสอบรายละเอียด" />
          <HeaderCustom label="ข้อมูลการเข้าสู่ระบบ" />
          <InformationFormBasic detail={props.data} readOnly />
        </>
      )}

      <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
        <Button className="primary back" onClick={handleCancel}>
          ยกเลิก
        </Button>
        <Button className="primary" loading={isLoading} onClick={handleSave}>
          ยืนยัน
        </Button>
      </div>
    </>
  );
};

export default CheckInformation;
